export default (programEdges) => programEdges.sort((a, b) => {
  const aNorm = a.node.metaProgramFullName.toLowerCase()
  const bNorm = b.node.metaProgramFullName.toLowerCase()
  if (aNorm < bNorm) {
    return -1
  }
  else if (aNorm > bNorm) {
    return 1
  }
  return 0
})
